// askSmart-ui/src/pages/TOSP/components/BuildingDetailsModal.tsx
import React from "react";
import { Building } from "../types";

interface BuildingDetailsModalProps {
  /** The building to display, or null when closed. */
  building: Building | null;
  onClose: () => void;
}

// Read-only view of a Building, so an admin can check what was entered without
// opening the edit form and risking an accidental change.
export default function BuildingDetailsModal({
  building,
  onClose,
}: BuildingDetailsModalProps) {
  if (!building) return null;

  const rows: { label: string; value: string }[] = [
    { label: "Building Name", value: building.name },
    { label: "Nickname", value: building.nickname || "—" },
    { label: "GSCC #", value: building.gsccNumber || "—" },
  ];

  return (
    <div className="smrtdocs-modal-overlay">
      <div className="smrtdocs-modal" style={{ width: "480px" }}>
        <div className="smrtdocs-modal-header">
          <h2 style={{ margin: 0, fontSize: "1rem" }}>Building Details</h2>
        </div>
        <div className="smrtdocs-modal-body">
          {rows.map((row) => (
            <div key={row.label} className="tosp-detail-row">
              <div className="tosp-detail-label">{row.label}</div>
              <div className="tosp-detail-value">{row.value}</div>
            </div>
          ))}

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button type="button" className="btn-cancel" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
